// Flow Star collection card: UV / Spin / Flip pill controls.
// Registered once; every card on the page is an instance of this element.
if (!customElements.get('fs-star-card')) {
  customElements.define(
    'fs-star-card',
    class FsStarCard extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.spinTarget = this.querySelector('[data-fs-spin-target]');
        this.stars = this.querySelectorAll('[data-fs-view]');
        this.uvButton = this.querySelector('[data-fs-uv]');
        this.uvLabel = this.querySelector('[data-fs-uv-label]');
        this.spinButton = this.querySelector('[data-fs-spin]');
        this.flipButton = this.querySelector('[data-fs-flip]');
        this.flipLabel = this.querySelector('[data-fs-flip-label]');
        this.pills = this.querySelectorAll('.fs-card__pill');

        this.uv = false;
        this.back = false;
        this.spinning = false;
        this.duration = (parseFloat(this.dataset.spinDuration) || 3) * 1000;

        this.dataset.uv = 'off';

        if (this.uvButton) {
          this.uvButton.addEventListener('click', (event) => this.onPill(event, () => this.toggleUv()));
        }
        if (this.flipButton) {
          this.flipButton.addEventListener('click', (event) => this.onPill(event, () => this.toggleFlip()));
        }
        if (this.spinButton) {
          this.spinButton.addEventListener('click', (event) => this.onPill(event, () => this.spin()));
        }
      }

      // The whole card sits under an overlay link, so a pill has to swallow the
      // click before it navigates through to the product page.
      onPill(event, action) {
        event.preventDefault();
        event.stopPropagation();
        if (this.spinning) return;
        action();
      }

      // Pill labels name the action the click performs, not the current state:
      // the UV pill reads "UV ON" while UV is still off. Both wordings live in
      // data attributes so the copy stays in Liquid.
      setPillState(button, labelEl, active) {
        if (!button) return;
        button.dataset.fsActive = String(active);
        const label = active ? button.dataset.fsLabelActive : button.dataset.fsLabelInactive;
        const aria = active ? button.dataset.fsAriaActive : button.dataset.fsAriaInactive;
        if (labelEl && label) labelEl.textContent = label;
        if (aria) button.setAttribute('aria-label', aria);
      }

      get view() {
        return (this.uv ? 'uv-' : '') + (this.back ? 'back' : 'front');
      }

      render() {
        const target = this.view;
        this.stars.forEach((star) => {
          star.classList.toggle('is-active', star.dataset.fsView === target);
        });
      }

      toggleUv() {
        this.uv = !this.uv;
        this.dataset.uv = this.uv ? 'on' : 'off';
        this.setPillState(this.uvButton, this.uvLabel, this.uv);
        this.render();
      }

      toggleFlip() {
        this.back = !this.back;
        this.setPillState(this.flipButton, this.flipLabel, this.back);
        this.render();
      }

      spin() {
        if (!this.spinTarget) return;
        this.spinning = true;
        this.pills.forEach((pill) => {
          pill.disabled = true;
        });

        // Restart the animation even if it was just running.
        this.spinTarget.classList.remove('is-spinning');
        void this.spinTarget.offsetWidth;
        this.spinTarget.classList.add('is-spinning');

        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          this.spinTarget.classList.remove('is-spinning');
          this.pills.forEach((pill) => {
            pill.disabled = false;
          });
          this.spinning = false;
        };

        // animationend is the accurate signal; the timeout is a safety net for
        // browsers that drop the event while the card is offscreen.
        this.spinTarget.addEventListener('animationend', finish, { once: true });
        setTimeout(finish, this.duration + 300);
      }
    }
  );
}